"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["NotSubmitted"] = "not_submitted";
    OrderStatus["Submitting"] = "submitting";
    OrderStatus["ReadyToSubmit"] = "ready_to_submit";
    OrderStatus["InSubmission"] = "in_submission";
    OrderStatus["Submitted"] = "submitted";
    OrderStatus["Retry"] = "retry";
    OrderStatus["Missing"] = "missing";
    OrderStatus["Error"] = "error";
    OrderStatus["MaxRetryAttemptsError"] = "error_max_retry_attempts";
    OrderStatus["InProgress"] = "in progress";
    OrderStatus["CreatedInDynamics"] = "created_in_dynamics";
    OrderStatus["ConfirmedInDynamics"] = "confirmed_in_dynamics";
    OrderStatus["Open"] = "open";
    OrderStatus["Backorder"] = "backorder";
    OrderStatus["Hold"] = "hold";
    OrderStatus["UpdateInProgress"] = "update in progress";
    OrderStatus["PartiallyShipped"] = "partially shipped";
    OrderStatus["Delivered"] = "delivered";
    OrderStatus["PartiallyInvoiced"] = "partially invoiced";
    OrderStatus["Invoiced"] = "invoiced";
    OrderStatus["Closed"] = "closed";
    OrderStatus["Deleted"] = "deleted";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
//# sourceMappingURL=order-status.enum.js.map